"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE_TYPES = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
exports.STYLE_TYPES = [
    {
        label: "H2",
        name: "title",
        style: "header-two",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Title, {}),
        type: "block",
    },
    {
        label: "Bold",
        name: "bold",
        style: "BOLD",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatBold, {}),
        type: "inline",
    },
    {
        label: "Italic",
        name: "italic",
        style: "ITALIC",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatItalic, {}),
        type: "inline",
    },
    {
        label: "Underline",
        name: "underline",
        style: "UNDERLINE",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatUnderlined, {}),
        type: "inline",
    },
    {
        label: "Strikethrough",
        name: "strikethrough",
        style: "STRIKETHROUGH",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.StrikethroughS, {}),
        type: "inline",
    },
    {
        label: "Highlight",
        name: "highlight",
        style: "HIGHLIGHT",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Highlight, {}),
        type: "inline",
    },
    {
        label: "Undo",
        name: "undo",
        style: "UNDO",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Undo, {}),
        type: "callback",
    },
    {
        label: "Redo",
        name: "redo",
        style: "REDO",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Redo, {}),
        type: "callback",
    },
    {
        label: "Link",
        name: "link",
        style: "LINK",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.InsertLink, {}),
        type: "callback",
        id: "link-control",
    },
    {
        label: "Media",
        name: "media",
        style: "IMAGE",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.PhotoLibrary, {}),
        type: "callback",
        id: "media-control",
    },
    {
        label: "UL",
        name: "bulletList",
        style: "unordered-list-item",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatListBulleted, {}),
        type: "block",
    },
    {
        label: "OL",
        name: "numberList",
        style: "ordered-list-item",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatListNumbered, {}),
        type: "block",
    },
    {
        label: "Blockquote",
        name: "quote",
        style: "blockquote",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatQuote, {}),
        type: "block",
    },
    {
        label: "Code Block",
        name: "code",
        style: "code-block",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Code, {}),
        type: "block",
    },
    {
        label: "Clear",
        name: "clear",
        style: "clear",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.FormatClear, {}),
        type: "callback",
    },
    {
        label: "Save",
        name: "save",
        style: "save",
        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Save, {}),
        type: "callback",
    },
];
//# sourceMappingURL=style-types.js.map